import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';

export class FileContent extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static FileContentProperties: (
    | {
        property: keyof FileContent;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof FileContent;
        type: 'alias';
      }
    | {
        property: keyof FileContent;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'filecontents', type: 'column', dataType: 'string' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' }
  ];

  static {
    FileContent.FileContentProperties.forEach((propertyObject) => {
      const { property, type } = propertyObject;
      if (type === 'column') {
        FileContent.columnMap.set(property, propertyObject);
      }
      if (type === 'alias') {
        FileContent.aliasedColumnMap.set(
          property,
          propertyObject as { property: string; type: 'alias' }
        );
      }
      if (type === 'association') {
        FileContent.associationMap.set(
          property,
          propertyObject as {
            property: string;
            type: 'association';
            model: string;
          }
        );
      }
    });
  }

  constructor(FileContentObject: Partial<FileContent>) {
    super();

    FileContent.FileContentProperties.forEach((propertyObject) => {
      const { property } = propertyObject;
      const value = FileContentObject[property];
      if (value !== undefined) {
        Object.assign(this, { [property]: value });
      }
    });
  }

  id?: number;
  filecontents?: string;
  createdAt?: Date;
  updatedAt?: Date;
}
